// Configuration for card visibility
// Set to false to hide a card, true to show it

export const CARD_VISIBILITY = {
  // Project cards
  "Portfolio Showcase": false,
  
  // Tool cards
  "Explain Like I'm 5": true,
  "Git Commit Genie": true,
  "Financial and Market Tools": true,
  "Content and Creator Tools": false, // Hidden as requested
  "Text-to-Study-Aids": true,
  "HR/Career Tools": true,
  "AI Math Puzzle Generator": false,
  "Daily Reflection Journal": false,
  "Legal Document Summarizer": false,
  "URL Shortener": true,
};

// Helper function to check if a card should be visible
export const isCardVisible = (cardTitle: string): boolean => {
  if (cardTitle in CARD_VISIBILITY) {
    return CARD_VISIBILITY[cardTitle as keyof typeof CARD_VISIBILITY];
  }
  // Default to showing cards not explicitly configured
  return true;
};
